import * as utils from "@/utils.js";
import isEmpty from "lodash/isEmpty";
import {
    SetInvestorImportedData,
    SetOtherChargeImportedData,
    SetInvestorsProgrammeData
} from "./EtudeFinanciereHelpers";

export default {
    //* getter for form component  "programme d'investissement et plan de financement version detailed "

    investmentProgramme: (state, getters, rootState) => {
        console.log(
            "🚀 ~ file: EtudeFinanciere.js ~ line 2052 ~ rootState",
            rootState
        );
        console.log("🚀 ~ file: EtudeFinanciere.js ~ line 2052 ~ state", state);
        if (!isEmpty(state.programmeDinvestissementPlanDeFinancement))
            return state.programmeDinvestissementPlanDeFinancement;

        if (
            rootState.user.bpi !== null &&
            !isEmpty(rootState.user.bpi.investors_programme)
        )
            return rootState.user.bpi.investors_programme;

        return SetInvestorImportedData(rootState);
    },

    otherCharge: (state, getters, rootState) => {
        if (!isEmpty(state.autresCharges))
            return {
                otherChargeResult: state.autresCharges.autreCharge,
                tauxDevolution: state.autresCharges.tauxEvolution
            };

        if (
            rootState.user.bpi !== null &&
            !isEmpty(rootState.user.bpi.autres_charges)
        )
            return {
                otherChargeResult:
                    rootState.user.bpi.autres_charges.autreCharge,
                tauxDevolution: rootState.user.bpi.autres_charges.tauxEvolution
            };

        return SetOtherChargeImportedData(rootState);
    },

    labourCharges: (state, getters, rootState) => {
        const TotalLabourCharges = [];
        const labours = rootState.EtudeTechnique.labourCard;
        if (labours.length === 0) return TotalLabourCharges;
        labours.forEach(labour => {
            TotalLabourCharges.push({
                name: labour.name,
                code: labour.code,
                effective: labour.value,
                salary: null,
                monthNumber: 12
            });
        });

        if (!isEmpty(state.fonctions)) {
            return {
                laboursCharge: state.fonctions.details,
                tauxDevolution: state.fonctions.tauxDevolution
            };
        }

        if (
            rootState.user.bpi !== null &&
            !isEmpty(rootState.user.bpi.charge_du_personnel)
        )
            return {
                laboursCharge: rootState.user.bpi.charge_du_personnel.details,
                tauxDevolution:
                    rootState.user.bpi.charge_du_personnel.tauxDevolution
            };

        return {
            laboursCharge: TotalLabourCharges,
            tauxDevolution: null
        };
    },

    getChiffreAffaire: (state, getters, rootState) => {
        if (!isEmpty(state.caDetails)) {
            if (state.caDetails.type === "CA Total") {
                return {
                    offersObject: [
                        {
                            model: "offer-card",
                            key: utils.generateUID(),
                            object: {
                                id: utils.generateUID(),
                                options: "",
                                units: "",
                                price: null,
                                quantiteVente: null,
                                pourcentagePartExportee: null,
                                date: null,
                                isExported: false,
                                name: ""
                            }
                        }
                    ],
                    type: "CA Total",
                    totalCAPrevisionnel: state.caDetails.totalCAPrevisionnel,
                    tauxEvolution: state.caDetails.tauxEvolution,
                    tauxRealisation: state.caDetails.tauxRealisation,
                    options: state.caDetails.options
                };
            } else {
                let offersObjects = state.caDetails.offersObject.map(offer => {
                    return {
                        model: "offer-card",
                        key: utils.generateUID(),
                        object: {
                            ...offer
                        }
                    };
                });
                return {
                    offersObject: offersObjects,
                    type: "CA Détails",
                    totalCAPrevisionnel: null,
                    tauxEvolution: state.TauxEvolutionChiffre,
                    tauxRealisation: state.TauxRealisationChiffre,
                    options: []
                };
            }
        }

        if (
            rootState.user.bpi !== null &&
            !isEmpty(rootState.user.bpi.chiffres_d_affaires_previsionnels)
        ) {
            const chiffreDaffaires =
                rootState.user.bpi.chiffres_d_affaires_previsionnels;

            let chiffreDaffairesObject = {};
            if (chiffreDaffaires.details.type === "CA Total") {
                chiffreDaffairesObject = {
                    totalCAPrevisionnel:
                        chiffreDaffaires.details.totalCAPrevisionnel,
                    tauxEvolution: chiffreDaffaires.tauxEvolution,
                    tauxRealisation: chiffreDaffaires.details.tauxRealisation,
                    type: chiffreDaffaires.details.type,
                    options: [...chiffreDaffaires.details.options],
                    offersObject: [
                        {
                            model: "offer-card",
                            key: utils.generateUID(),
                            object: {
                                id: utils.generateUID(),
                                options: "",
                                units: "",
                                price: null,
                                quantiteVente: null,
                                pourcentagePartExportee: null,
                                date: null,
                                isExported: false,
                                name: ""
                            }
                        }
                    ]
                };
            } else {
                let offersObject = chiffreDaffaires.details.offersObject.map(
                    offer => {
                        return {
                            model: "offer-card",
                            key: utils.generateUID(),
                            object: {
                                ...offer
                            }
                        };
                    }
                );
                chiffreDaffairesObject = {
                    totalCAPrevisionnel: null,
                    tauxEvolution: chiffreDaffaires.tauxEvolution,
                    tauxRealisation: chiffreDaffaires.tauxRealisation,
                    type: "CA Détails",
                    options: [],
                    offersObject: offersObject
                };
            }

            return chiffreDaffairesObject;
        }

        return {
            offersObject: [
                {
                    model: "offer-card",
                    key: utils.generateUID(),
                    object: {
                        id: utils.generateUID(),
                        options: "",
                        units: "",
                        price: null,
                        quantiteVente: null,
                        pourcentagePartExportee: null,
                        date: null,
                        isExported: false,
                        name: ""
                    }
                }
            ],
            type: "CA Total",
            totalCAPrevisionnel: null,
            tauxEvolution: null,
            tauxRealisation: null,
            options: []
        };
    },

    getAcharPrev: (state, getters, rootState) => {
        if (!isEmpty(state.achatsPrevisionnel)) {
            if (state.achatsPrevisionnel.type === "total") {
                return {
                    tauxEvolution: state.achatsPrevisionnel.tauxEvolution,
                    type: state.achatsPrevisionnel.type,
                    isImporter: state.achatsPrevisionnel.isImporter,
                    totalPrice: state.achatsPrevisionnel.totalPrice,
                    pourcentageAchatImport:
                        state.achatsPrevisionnel.pourcentageAchatImport,
                    achatObject: [
                        {
                            model: "achat-card",
                            key: utils.generateUID(),
                            object: {
                                id: utils.generateUID(),
                                isImporter: false,
                                name: "",
                                prixAchat: null,
                                quantite: 0,
                                date: null,
                                unite: "",
                                pourcentagePartImportee: 0,
                                choixArticle: ""
                            }
                        }
                    ]
                };
            } else {
                let achatArrays = state.achatsPrevisionnel.achats.map(achat => {
                    return {
                        model: "achat-card",
                        key: utils.generateUID(),

                        object: {
                            ...achat
                        }
                    };
                });
                return {
                    tauxEvolution: state.tauxEvolutionAchats,
                    type: "details",
                    isImporter: false,
                    totalPrice: null,
                    pourcentageAchatImport: null,
                    achatObject: achatArrays
                };
            }
        }

        if (
            rootState.user.bpi !== null &&
            !isEmpty(rootState.user.bpi.achats_previsionnel)
        ) {
            const achatPrev = rootState.user.bpi.achats_previsionnel;

            let achatPrevObject = {};
            if (achatPrev.details.type === "total") {
                achatPrevObject = {
                    tauxEvolution: achatPrev.tauxEvolution,
                    type: achatPrev.details.type,
                    isImporter: achatPrev.details.isImporter,
                    totalPrice: achatPrev.details.totalPrice,
                    pourcentageAchatImport:
                        achatPrev.details.pourcentageAchatImport,
                    achatObject: [
                        {
                            model: "achat-card",
                            key: utils.generateUID(),
                            object: {
                                id: utils.generateUID(),
                                isImporter: false,
                                name: "",
                                prixAchat: null,
                                quantite: 0,
                                date: null,
                                unite: "",
                                pourcentagePartImportee: 0,
                                choixArticle: ""
                            }
                        }
                    ]
                };
            } else {
                const achatArray = achatPrev.details.achats.map(achat => {
                    return {
                        model: "achat-card",
                        key: utils.generateUID(),

                        object: {
                            ...achat
                        }
                    };
                });
                achatPrevObject = {
                    tauxEvolution: achatPrev.tauxEvolution,
                    type: "details",
                    isImporter: false,
                    totalPrice: null,
                    pourcentageAchatImport: null,
                    achatObject: achatArray
                };
            }

            return achatPrevObject;
        }

        return {
            achatObject: [
                {
                    model: "achat-card",
                    key: utils.generateUID(),
                    object: {
                        id: utils.generateUID(),
                        isImporter: false,
                        name: "",
                        prixAchat: null,
                        quantite: 0,
                        date: null,
                        unite: "",
                        pourcentagePartImportee: 0,
                        choixArticle: ""
                    }
                }
            ],
            type: "total",
            tauxEvolution: null,
            isImporter: false,
            totalPrice: null,
            pourcentageAchatImport: null
        };
    },

    //* getter for form component  "programme d'investissement et plan de financement version simplified"

    getInvestmentProgramme: (state, getters, rootState) => {
        if (!isEmpty(state.programmeDinvestissementPlanDeFinancement))
            return state.programmeDinvestissementPlanDeFinancement;

        if (
            rootState.user.bpi !== null &&
            !isEmpty(rootState.user.bpi.investors_programme)
        ) {
            return rootState.user.bpi.investors_programme;
        }

        return SetInvestorsProgrammeData(rootState);
    },

    getChargesPreevisionnels: (state, getters, rootState) => {
        const chargesPreevisionnels = {
            autreCharge: [],
            tauxEvolution: null,
            achatsPrevisionnel: null
        };

        if (!isEmpty(state.fonctions)) {
            return {
                autreCharge: state.chargePrevisionnel.autreCharge,
                tauxEvolution: state.chargePrevisionnel.tauxEvolution,
                achatsPrevisionnel: state.chargePrevisionnel.achatsPrevisionnel
            };
        }

        if (
            rootState.user.bpi !== null &&
            !isEmpty(rootState.user.bpi.charge_previsonnel)
        )
            return rootState.user.bpi.charge_previsonnel;
        return chargesPreevisionnels;
    }
};
